import { render, staticRenderFns } from "./TCLAAnchors.vue?vue&type=template&id=13166218&scoped=true"
import script from "./TCLAAnchors.vue?vue&type=script&lang=js"
export * from "./TCLAAnchors.vue?vue&type=script&lang=js"
import style0 from "./TCLAAnchors.vue?vue&type=style&index=0&id=13166218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13166218",
  null
  
)

export default component.exports